import { all, call, put, takeEvery } from "redux-saga/effects"
import {
  getAxisCareReportsFailed,
  getAxisCareReportsSuccess,
  getAxisCareSetupFailed,
  getAxisCareSetupSuccess,
  initAxisCareFailed,
  initAxisCareSuccess,
} from "./actions"
import { get, getVendorsAxios } from "helpers/api_helper"
import * as url from "helpers/url_helper"
import { showToast } from "utils"
import {
  GET_AXISCARE_REPORTS,
  GET_AXISCARE_SETUP,
  INIT_AXISCARE,
} from "./actionTypes"

function* getAxisCareReports({ payload: params }) {
  try {
    const response = yield get(url.AXISCARE_REPORTS_URL, { params })
    yield put(getAxisCareReportsSuccess(response))
  } catch (error) {
    yield put(getAxisCareReportsFailed(error))
  }
}

function* getAxisCareSetup({ payload: params }) {
  try {
    const response = yield getVendorsAxios(
      `${url.GET_VENDOR_URL}/${params.vendor_id}${url.GET_CLIENT_CONFIG}`
    )
    yield put(getAxisCareSetupSuccess(response))
  } catch (error) {
    yield put(getAxisCareSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* initAxisCare({ payload: params }) {
  try {
    yield all([
      call(getAxisCareReports, {
        payload: {
          page: 1,
          per_page: 15,
          order: "first_name",
          direction: "asc",
        },
      }),
      call(getAxisCareSetup, { payload: { vendor_id: params?.vendor_id } }),
    ])

    yield put(initAxisCareSuccess())
  } catch (error) {
    yield put(initAxisCareFailed(error))
  }
}

function* axisCareSaga() {
  yield takeEvery(GET_AXISCARE_REPORTS, getAxisCareReports)
  yield takeEvery(GET_AXISCARE_SETUP, getAxisCareSetup)
  yield takeEvery(INIT_AXISCARE, initAxisCare)
}

export default axisCareSaga
